import { DotLottie } from '@lottiefiles/dotlottie-web';

document.addEventListener("DOMContentLoaded", function() {
    const heroBlock = document.querySelector('section.banner-wrapper');

    if(heroBlock) {
        let slides = heroBlock.querySelectorAll('.media-slide');

        const animations = document.querySelectorAll('.hero-animation');
        const players = [];

        if (animations) {
            function setup() {
                animations.forEach(element => loadAnimation(element));
            }

            setup();
            setTimeout(setup, 1000);
            setTimeout(setup, 3000);

            function loadAnimation(element) {
                if (element.classList.contains('loaded')) {
                    return;
                }

                const data = element.querySelector('.data code');

                if (!data) {
                    return;
                }

                let animationData;

                try {
                    animationData = JSON.parse(data.textContent);
                } catch (e) {
                    return;
                }

                // dotLottie draws to a canvas, so the container gets one rather than
                // being handed to the player itself. A canvas has no intrinsic size
                // the way the old svg had, so take the ratio from the animation.
                const canvas = document.createElement('canvas');
                canvas.style.width = '100%';

                if (animationData.w && animationData.h) {
                    canvas.style.aspectRatio = animationData.w + ' / ' + animationData.h;
                }

                element.insertBefore(canvas, element.firstChild);

                players.push(new DotLottie({
                    canvas: canvas, // Required
                    data: animationData, // Inline JSON, as opposed to src which fetches a URL
                    loop: true, // Optional
                    autoplay: true, // Optional
                    layout: { fit: 'contain', align: [0.5, 0.5] }, // Optional
                    renderConfig: { autoResize: true }, // Optional
                }));

                element.classList.add('loaded');
            }
        }

        if(slides.length > 0) {
            slides.forEach(function(slide) {
                let videoControls = slide.querySelector('.video-controls');

                if(videoControls) {
                    let playBtn = videoControls.querySelector('button.play-icon');
                    let pauseBtn = videoControls.querySelector('button.pause-icon');
                    playBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        this.closest('.media-slide').querySelectorAll('.pause-icon').forEach(function(icon) {
                            icon.classList.add('show');
                        });
                        this.closest('.media-slide').querySelectorAll('.play-icon').forEach(function(icon) {
                            icon.classList.remove('show');
                        });
                        slide.closest('.media-slide').querySelectorAll('.media-video video').forEach(function(video) {
                            video.play();
                        });
                    });
                    pauseBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        this.closest('.media-slide').querySelectorAll('.pause-icon').forEach(function(icon) {
                            icon.classList.remove('show');
                        });
                        this.closest('.media-slide').querySelectorAll('.play-icon').forEach(function(icon) {
                            icon.classList.add('show');
                        });
                        slide.closest('.media-slide').querySelectorAll('.media-video video').forEach(function(video) {
                            video.pause();
                        });
                    });
                }
            });
        }

        $(".section__banner .scrollDownArrowLink").click((e) => {
            e.preventDefault();
            $this = $(e.target);
        
            $("html, body").animate({
                scrollTop: $this.parents(".banner-wrapper").next().offset().top
            }, 500);
        })
    }
});